import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './auth-layout.component';

export const AUTH_ROUTES: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./login/login.component').then((c) => c.LoginComponent),
      },
      {
        path: 'signup',
        loadComponent: () =>
          import('./signup-v2/signup-v2.component').then(
            (c) => c.SignupV2Component,
          ),
      },
      {
        path: 'invite',
        loadComponent: () =>
          import('./invite/invite.component').then((c) => c.InviteComponent),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./forgot-password/forgot-password.component').then(
            (c) => c.ForgotPasswordComponent,
          ),
      },
      {
        path: 'change-password',
        loadComponent: () =>
          import('./change-password/change-password.component').then(
            (c) => c.ChangePasswordComponent,
          ),
      },
    ],
  },
];
